import { createSlice } from "@reduxjs/toolkit";

const companiesSlice = createSlice({
  name: "companies",
  initialState: [],
  reducers: {
    addCompaniesList: (state, action) => action.payload,
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = companiesSlice;

// Extract and export each action creator by name
export const { addCompaniesList } = actions;

// Export the reducer, either as a default or named export
export default reducer;
